module.exports = __webpack_public_path__ + "static/media/3.51ca114b.jpg";